import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'objectAssign',
})
export class AssignPipe implements PipeTransform {
  transform<U>(value: undefined, obj: U): U;
  transform<T>(value: T, obj: undefined): T;
  transform<T, U>(value: T, obj: U): T & U;
  transform(value = {}, obj = {}) {
    return Object.assign(value, obj);
  }
}
